import axios from 'axios';

export const getFreeDomains = () =>
  axios('https://f.hubspotusercontent40.net/hubfs/2832391/Marketing/Lead-Capture/free-domains-1.csv')